import { createEvent, sample } from 'effector'
import { BanRequest, BanRequestData } from './types'
import { fx } from '../../../../../libs'
import { Participant } from '../../list/types'
import { restore } from 'effector/effector.umd'

export const banMounted = createEvent<BanRequestData>()

export const setIsBanClientSuccess = createEvent<boolean>()

export const $isBanClientSuccess = restore(setIsBanClientSuccess, false)

export const banClient = fx<BanRequest, void>({
  method: 'PUT',
  url: `/promo/golden-may/participant/{clientId}`,
})

sample({
  clock: banMounted,
  fn: ({ banReason, id }) => {
    return {
      url: `/promo/golden_may/participant/${id}`,
      body: {
        banReason: banReason,
      },
    }
  },
  target: banClient,
})

sample({
  clock: banClient.doneData,
  fn: () => {
    return true
  },
  target: setIsBanClientSuccess,
})
